import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Axios from 'axios';
import * as echarts from 'echarts';

import * as serviceWorker from './serviceWorker';

// 設定 Axios HTTP Request 參數
// 若為線上環境則使用設備自已的網址
Axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/api';
if (process.env.NODE_ENV === "development") {
  // 若為開發環境則將網址指向實體設備的 IP 位置
  Axios.defaults.baseURL = process.env.REACT_APP_API_DOMAIN;
}
echarts.registerLocale('zh-tw', {
  time: {
    month: [
      '一月', '二月', '三月', '四月', '五月', '六月',
      '七月', '八月', '九月', '十月', '十一月', '十二月'
    ],
    monthAbbr: [
      '1月', '2月', '3月', '4月', '5月', '6月',
      '7月', '8月', '9月', '10月', '11月', '12月'
    ],
    dayOfWeek: [
      '星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'
    ],
    dayOfWeekAbbr: [
      '日', '一', '二', '三', '四', '五', '六'
    ]
  }
});

// For React 17
// ReactDOM.render(
//   <App />,
//   document.getElementById('root')
// );

// For React 18
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
